import { getRgObjectsOfType as f, RG_TYPE as s } from "@project-rouge/rg-core";
import { isLiftCore as g } from "../../queries/index5.js";
import { getLevelCount as m } from "../../object-helpers/index3.js";
const p = (r) => {
  let e = 0;
  const l = f(r, s.Building);
  for (const o of l) {
    const n = m(o);
    for (let t = 0; t < n; t++)
      o.children.some((i) => i.data.level === t && g(i)) && e++;
  }
  return e;
};
export {
  p as getLiftLevels
};
//# sourceMappingURL=index32.js.map
